import { render, staticRenderFns } from "./CheckoutApprovedFeedback.vue?vue&type=template&id=0c44b88e&scoped=true"
import script from "./CheckoutApprovedFeedback.vue?vue&type=script&lang=js"
export * from "./CheckoutApprovedFeedback.vue?vue&type=script&lang=js"
import style0 from "./CheckoutApprovedFeedback.vue?vue&type=style&index=0&id=0c44b88e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c44b88e",
  null
  
)

export default component.exports